import './HoursStatistic.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useRef } from "react";

import { fetchHours } from "../../slices/statisticSlice";

import { Box } from "@mui/material";

import ReactECharts from "echarts-for-react";

const HoursStatistic = ({params}) => {
    const dispatch = useDispatch();
    const statisticData = useSelector((state) => state.statistic.hoursStatistic);
    const token = useSelector((state) => state.auth.token?.data?.token || state.auth.token);
    const chartRef = useRef(null);

    useEffect(() => {
        dispatch(fetchHours({token, params}));
    }, [dispatch, token, params]);

    useEffect(() => {
        setTimeout(() => {
            chartRef.current?.getEchartsInstance().resize();
        }, 100);
    }, [statisticData]);

    const categories = statisticData.map(item => item.emergency_type.alias || item.emergency_type.name);
    const workerManHours = statisticData.map(item => parseFloat(item.worker_man_hours) || 0);

    const options = {
        title: {
            text: 'Человеко-часы по типам аварий',
            left: 'center'
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
            formatter: (params) => {
                const { name, value } = params[0];
                return `${name}: ${value} ч`;
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '15%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: categories,
            axisLabel: {
                rotate: 30,
                fontSize: 10
            }
        },
        yAxis: {
            type: 'value',
            name: 'Человеко-часы',
            axisLabel: {
                formatter: '{value} ч'
            }
        },
        series: [
            {
                name: 'Человеко-часы',
                type: 'bar',
                data: workerManHours,
                itemStyle: { color: '#4CAF50' }
            }
        ]
    };

    return (
        <Box className="hours_statistic">
            <ReactECharts ref={chartRef} option={options} style={{ width: '100%', height: '100%' }} />
        </Box>
    );
};

export default HoursStatistic;